<!--
 * @Author:
 * @LastEditTime: 2024-06-17 16:15:32
 * @Description: 承包商单位退厂
-->
<template>
  <el-card class="h-full">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <div>
          <el-input
            size="small"
            class="mr-10px !w-54"
            placeholder="单位名称、单位负责人"
            v-model="searchData.orgNameOrOrgLeader"
            clearable
          ></el-input>
          <el-select
            v-model="searchData.status"
            size="small"
            class="mr-10px !w-54"
            placeholder="请选择单位状态"
            clearable
          >
            <el-option
              v-for="item in statusFilterList"
              :key="item.code"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
          <el-select
            v-model="searchData.isBlock"
            size="small"
            class="mr-10px !w-54"
            placeholder="请选择是否黑名单"
            clearable
          >
            <el-option
              v-for="item in blackList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="searchData.workflowStatus"
            size="mini"
            placeholder="流程状态"
            class="!w-50 mr-10px"
            clearable
          >
            <el-option
              v-for="item in workFlowStatusList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>
      <el-table :data="dataList" border :height="tableHeight" stripe v-loading="tableLoading">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="单位名称" prop="orgName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="所属项目"
          prop="projectNames"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="单位负责人"
          prop="orgLeader"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="单位状态" prop="status" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
              unitStatusMap(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="100" label="是否黑名单" prop="isBlock">
          <template slot-scope="scope">
            <el-tag size="mini" type="danger" v-if="scope.row.isBlock === true">是</el-tag>
            <el-tag size="mini" type="success" v-else-if="scope.row.isBlock === false">否</el-tag>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="流程状态" prop="workflowStatus" width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              v-if="scope.row.workflowStatus !== 0"
              :type="workFlowStatusTypes(scope.row.workflowStatus)"
              >{{ workFlowStatusMap(scope.row.workflowStatus) }}</el-tag
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="320">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <div v-if="currentComp === 'DETAIL'" class="relative w-full h-full">
      <div class="absolute top-8 right-16 z-99">
        <el-button @click="openFlowDialog" v-if="$hasAccess('readFlow') && flowTaskId"
          >查看流程</el-button
        >
      </div>
      <el-dropdown
        placement="bottom-start"
        :hide-on-click="false"
        v-if="isShowDropdownMenu"
        class="absolute top-8 right-2 z-99"
      >
        <el-button type="primary" size="small">
          <i class="iconfont icon-line-moreHorizontal text-14px font-bold"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <p class="pl-4 font-bold text-base custom-title">单位档案</p>
          <el-dropdown-item v-for="(item, index) in moduleNeedList" :key="index">
            <div>
              <el-checkbox v-model="item.checked">{{ item.moduleName }}</el-checkbox>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-10px cursor-pointer">
          <el-page-header @back="handleBack" content="详情"></el-page-header>
        </div>
      </div>

      <el-tabs v-model="activeModule">
        <el-tab-pane
          v-for="item in moduleShowList"
          :key="item.module"
          :label="item.moduleName"
          :name="item.module"
        ></el-tab-pane>
      </el-tabs>
      <div class="w-full detail-height">
        <!-- 基本信息 -->
        <base-info
          ref="BaseInfo"
          @back="handleBack"
          @save="refreshList"
          :pageType="pageType"
          v-if="activeModule === '0'"
          :contractId="contractId"
          :taskId="taskId"
        ></base-info>
        <!-- 申报人员名册 -->
        <applicants-info
          ref="ApplicantsInfo"
          :contractId="contractId"
          v-if="activeModule === '1'"
        ></applicants-info>
        <!-- 关联项目 -->
        <relate-project-info
          ref="RelateProjectInfo"
          v-if="activeModule === '2'"
          :contractId="contractId"
        ></relate-project-info>
        <!-- 事故事件 -->
        <!-- <accident-event-info
          ref="AccdientEventInfo"
          v-if="activeModule === '3'"
        ></accident-event-info> -->
        <!-- 巡检记录 -->
        <!-- <inspect-records-info
          ref="InspectRecordsInfo"
          v-if="activeModule === '4'"
        ></inspect-records-info> -->
        <!-- 两票档案 -->
        <!-- <tickets-files ref="TicketsFiles" v-if="activeModule === '5'"></tickets-files> -->
      </div>
    </div>

    <!-- 退厂 -->
    <el-dialog
      :close-on-click-modal="false"
      title="单位退厂"
      :visible.sync="dialogLeaveShow"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form ref="leaveForm" label-width="150px" :rules="rulesForm" :model="leaveForm">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="单位名称" prop="unitName">
              <el-input v-model="currentContractor.orgName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传退厂单" prop="exitRecordFormFileId" ref="exitRecordFormFileId">
              <form-upload
                v-model="leaveForm.exitRecordFormFileId"
                @change="fileIdChange('exitRecordFormFileId')"
              ></form-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" :loading="leaveLoading" @click="handleSubmit"
          >确定</el-button
        >
        <el-button size="small" @click="dialogLeaveShow = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 出入厂历史记录 -->
    <enter-and-leave-records
      :contractId="contractId"
      v-if="dialogRecordsShow"
      @cancel="handleRecordsClose"
    ></enter-and-leave-records>

    <!-- 流程弹窗 -->
    <ApprovalFlowDialog
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
  </el-card>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import { ContractorApi } from '@wiz-api/contractor-management'

import FormUpload from '@/components/safety/FileUpload/FormUpload'
import BaseInfo from '@/components/safety/WizSafetyPage/unit/BaseInfo'
import AccidentEventInfo from '@/components/safety/WizSafetyPage/unit/AccidentEventInfo'
import ApplicantsInfo from '@/components/safety/WizSafetyPage/unit/ApplicantsInfo'
import InspectRecordsInfo from '@/components/safety/WizSafetyPage/unit/InspectRecordsInfo'
import RelateProjectInfo from '@/components/safety/WizSafetyPage/unit/RelateProjectInfo'
import TicketsFiles from '@/components/safety/WizSafetyPage/unit/TicketsFiles'
import EnterAndLeaveRecords from '@/components/safety/WizSafetyPage/unit/EnterAndLeaveRecords'
import { unitStatusTypes, workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import qs from 'qs'
const contractorApi = new ContractorApi()

export default {
  name: 'contractor-unit-leave',
  components: {
    BaseInfo,
    ApplicantsInfo,
    RelateProjectInfo,
    FormUpload,
    EnterAndLeaveRecords,
    TableOperateButton,
    ApprovalFlowDialog,
  },
  data() {
    return {
      pageType: '',
      leaveLoading: false,
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      // 用于审批
      taskId: null,
      approvalFlowDialog: false,
      // 用于查看流程
      flowTaskId: null,
      rowId: null,
      workFlowStatusList: [],
      currentContractor: {
        id: '',
        orgName: '',
      },
      dialogRecordsShow: false,
      statusList: [],
      contractId: null,
      activeModule: '0',
      moduleList: [
        {
          module: '0',
          moduleName: '基本信息',
          checked: true,
        },
        {
          module: '1',
          moduleName: '申报人员名册',
          checked: true,
        },
        {
          module: '2',
          moduleName: '关联项目',
          checked: true,
        },
        // {
        //   module: '3',
        //   moduleName: '事故事件',
        //   checked: true,
        // },
        // {
        //   module: '4',
        //   moduleName: '巡检记录',
        //   checked: true,
        // },
        // {
        //   module: '5',
        //   moduleName: '两票档案',
        //   checked: true,
        // },
      ],
      dialogLeaveShow: false,
      leaveForm: {
        exitRecordFormFileId: '',
      },
      rulesForm: {
        exitRecordFormFileId: [
          { required: true, message: '请上传退厂单', trigger: ['change', 'blur'] },
        ],
      },
      currentComp: 'TABLE',
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        isBlock: undefined,
        orgNameOrOrgLeader: '',
        status: null,
        // 是否为单位档案，查询除去待入厂的单位
        isExitFind: true,
        workflowStatus: null,
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  created() {
    // 单位退厂代办页面改造
    if (this.$route.query.id && this.$route.query.taskId && this.$route.query.mode) {
      // 用于审批
      this.taskId = this.$route.query.taskId
      this.handleDetail(
        { id: this.$route.query.id, flowTaskId: this.$route.query.taskId },
        this.$route.query.mode === 'approve' ? 'approve' : ''
      )
    }
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.IncomingfactoryStatus',
        'ContractorManagement.DataCategory.WorkflowStatus',
      ],
      ['statusList', 'workFlowStatusList'],
      this
    )
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    statusFilterList() {
      return this.statusList.filter((item) => {
        return item.code !== '0'
      })
    },
    // 去除基本信息
    moduleNeedList() {
      return this.moduleList.filter((item) => {
        return item.module !== '0'
      })
    },
    // 是否显示过滤菜单
    isShowDropdownMenu() {
      return this.moduleList.length > 1
    },
    // 过滤未选中的面板
    moduleShowList() {
      return this.moduleList.filter((item) => {
        return item.checked
      })
    },
    unitStatusMap() {
      return (val) => {
        return (
          this.statusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    workFlowStatusMap() {
      return (val) => {
        return (
          this.workFlowStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleDetail(val)
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '退厂',
            click: () => {
              return this.handleLeave(val)
            },
            // 显示按钮：单位状态在厂，流程状态不为审核中，且不为黑名单，单位的人员中不存在状态为审核中的
            isShow:
              this.$hasAccess('leave') &&
              val.status === 1 &&
              [0, 3].includes(val.workflowStatus) &&
              !val.isBlock,
          },
          {
            text: '出入厂记录',
            click: () => {
              return this.handleHsitoryRecord(val)
            },
            isShow: this.$hasAccess('historyRecord'),
          },
          {
            text: '审批',
            click: () => {
              return this.handleAudit(val)
            },
            // 审批code为001，且单位状态为在厂
            isShow:
              this.$hasAccess('audit') &&
              val.oprateCode === '001' &&
              [1].includes(val.status) &&
              val.workflowStatus === 1,
          },
          {
            text: '查看流程',
            click: () => {
              return this.handleFlow(val)
            },
            isShow: this.$hasAccess('readFlow') && val.flowTaskId,
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  methods: {
    handleAudit(row) {
      this.taskId = row.taskId
      this.handleDetail({ id: row.id, flowTaskId: row.flowTaskId }, 'approve')
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    // 退厂
    handleLeave(row) {
      this.leaveForm = this.$options.data().leaveForm
      this.dialogLeaveShow = true
      this.currentContractor = {
        id: row.id,
        orgName: row.orgName,
      }
    },
    // 退厂保存
    handleSubmit() {
      this.$refs.leaveForm.validate(async (valid) => {
        if (valid) {
          this.leaveLoading = true
          const [err, res] = await contractorApi.exitSubmit({
            body: { ...this.leaveForm, contactorId: this.currentContractor.id },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.dialogLeaveShow = false
            this.handleSearch()
          }
          this.leaveLoading = false
        }
      })
    },
    // 出入厂记录
    handleHsitoryRecord(row) {
      this.contractId = row.id
      this.dialogRecordsShow = true
    },
    // 关闭出入厂历史记录
    handleRecordsClose() {
      this.dialogRecordsShow = false
    },
    // 查看流程
    handleFlow(row) {
      this.flowTaskId = row.flowTaskId
      this.openFlowDialog()
    },
    openFlowDialog(){
      if(typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId,'-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    // 返回页面
    async handleBack() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
    },
    // 刷新列表
    async refreshList() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
      this.handleSearch()
    },
    /**
     * 详情
     * @param {*} row 行数据
     */
    async handleDetail(row, type = '') {
      this.contractId = row.id
      this.currentComp = null
      this.pageType = type
      // 用于详情查看流程
      this.flowTaskId = row.flowTaskId
      this.$nextTick(() => {
        this.currentComp = 'DETAIL'
      })
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取列表
    async getList() {
      this.tableLoading = true
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      }
      if (window.__POWERED_BY_QIANKUN__) { // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(`/api/contractor-management/contractors/paged-list-query?${qs.stringify({...data, ...this.searchData})}`)
        if (res.status === 200 && res.data) { 
          this.dataList = res.data.items || []
          this.totalCount = res.data.totalCount || 0
        }
        this.tableLoading = false
        return
      }
      const [error, result] = await contractorApi.pagedListQuery({ ...data, ...this.searchData })
      if (!error) {
        if (result.items) {
          this.dataList = result.items || []
          this.totalCount = result.totalCount || 0
        }
      }
      this.tableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}

.title {
  color: var(--textColor);
  position: relative;
  &::before {
    position: absolute;
    content: '';
    width: 2px;
    height: 70%;
    left: -8px;
    top: 4px;
    background-color: var(--systemColor);
  }
}

.detail-height {
  height: calc(100% - 102px);
}

.custom-title {
  color: var(--textColor);
}
</style>
